import {DocumentNode, gql} from "@apollo/client";

export const UPDATE_API_KEY_MUTATION: DocumentNode = gql(`
    mutation UpdateApiKey {
        updateApiKey {
            apiKey
        }
    }
`);
